import { ActionTypes } from '../types/actionTypes';
import { ISetEtpRegistrationInn, ISetEtpRegistrationSearchResult } from '../types/actions';

export const setEtpRegistrationInn = (payload: string): ISetEtpRegistrationInn => ({
  type: ActionTypes.SET_ETP_REGISTRATION_INN,
  payload,
});

export const setEtpRegistrationSearchResult = (
  payload: {
    inn: string;
    kpp: string;
    name: string;
    sections: { accredited_at: string; section_code: string; section_title: string }[];
    short_name: string;
  }[],
): ISetEtpRegistrationSearchResult => ({
  type: ActionTypes.SET_ETP_REGISTRATION_SEARCH_RESULT,
  payload,
});

export const setETPRegistrationLoading = (payload: boolean) => ({
  type: ActionTypes.SET_ETP_REGISTRATION_LOADING,
  payload,
});
export const setETPRegistrationError = (payload: string) => ({
  type: ActionTypes.SET_ETP_REGISTRATION_ERRORS,
  payload,
});
